import MUIBackdrop from '@mui/material/Backdrop'
import MUICircularProgress from '@mui/material/CircularProgress'
export interface IBackdropProps {
  open: boolean
}
export default function Backdrop({ open }: IBackdropProps) {
  return (
    <MUIBackdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }} open={open}>
      <MUICircularProgress color="inherit" />
    </MUIBackdrop>
  )
}
